import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Row, Label, Input, Button } from 'reactstrap';
import { getConfiguration, getEmailConfiguration, postConfiguration, putEmailConfiguration } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';

const Configrations = () => {
    const [configuration, setConfiguration] = useState({ integration: "", webhook: "", apiKey: "", apiSecret: "", isEnabled: false })
    const [emailSummary, setEmailSummary] = useState({ callSummaryEmail: false, campaignSummaryEmail: false, invoiceEmail: false })
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ integration: "", webhook: "", apiKey: "", apiSecret: "" });
    const [update, setUpdate] = useState(0);

    useEffect(() => {
        fetchEmailConfiguration();
    }, [update])


    const fetchEmailConfiguration = () => {
        setLoading(true)
        getEmailConfiguration().then(({ data }) => {
            if (data) {
                setEmailSummary(data ? data : { callSummaryEmail: false, campaignSummaryEmail: false, invoiceEmail: false })
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const handleConfigurationChange = (field, value) => {
        const updatedState = {
            ...emailSummary,
            [field]: value
        };

        setEmailSummary(updatedState);

        setLoading(true);

        putEmailConfiguration({
            callSummaryEmail: updatedState.callSummaryEmail,
            campaignSummaryEmail: updatedState.campaignSummaryEmail,
            invoiceEmail: updatedState.invoiceEmail
        })
            .then(() => {
                showToast("success", "Configuration Changed", "Your configuration has been changed successfully.");
                setUpdate(prev => prev + 1);
                setLoading(false);
            })
            .catch(() => {
                showToast("error", "Configuration Request Failed", "Your configuration could not be changed.");
                setLoading(false);
            });
    };
    return (
        <div className="content-page">
            <div className="content">

                <div className="container-fluid">
                    <div className="py-3 row">
                        <div className="col-12">
                            <Row className="my-2 align-items-center">
                                <Col md={12}>
                                    <h4 className='fs-18'>Configuration</h4>
                                    <p className='text-muted fs-12'>Set up your configuration</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row>
                        <Col md={4} className='mb-2'>
                            <Card className='bg-white rounded-4 h-100'>
                                <CardBody>
                                    <h4 className='fs-22 fw-600 mb-4 mt-2'>Call Summary</h4>
                                    <Row className='mb-1'>
                                        <Col md={8}>
                                            <p className='fs-15 mb-0 text-black'>Email me the Inbound Call Summary</p>
                                        </Col>
                                        <Col md={4} className='text-right'>
                                            <div className="form-check form-switch gradient-switch agent-update-switch" dir="ltr">
                                                <input role='switch' type="checkbox" checked={emailSummary.callSummaryEmail} onChange={(e) => { handleConfigurationChange("callSummaryEmail", e.target.checked); }} className="form-check-input float-right" />
                                            </div>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={4} className='mb-2'>
                            <Card className='bg-white rounded-4 h-100'>
                                <CardBody>
                                    <h4 className='fs-22 fw-600 mb-4 mt-2'>Campaign Summary</h4>
                                    <Row className='mb-1'>
                                        <Col md={8}>
                                            <p className='fs-15 mb-0 text-black'>Email me the Outbound Summary</p>
                                        </Col>
                                        <Col md={4} className='text-right'>
                                            <div className="form-check form-switch gradient-switch agent-update-switch" dir="ltr">
                                                <input role='switch' type="checkbox" checked={emailSummary.campaignSummaryEmail} onChange={(e) => { handleConfigurationChange("campaignSummaryEmail", e.target.checked); }} className="form-check-input float-right" />
                                            </div>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={4} className='mb-2'>
                            <Card className='bg-white rounded-4 h-100'>
                                <CardBody>
                                    <h4 className='fs-22 fw-600 mb-4 mt-2'>Invoice</h4>
                                    <Row className='mb-1'>
                                        <Col md={8}>
                                            <p className='fs-15 mb-0 text-black'>Email me the invoice</p>
                                        </Col>
                                        <Col md={4} className='text-right'>
                                            <div className="form-check form-switch gradient-switch agent-update-switch" dir="ltr">
                                                <input role='switch' type="checkbox" checked={emailSummary.invoiceEmail} onChange={(e) => { handleConfigurationChange("invoiceEmail", e.target.checked); }} className="form-check-input float-right" />
                                            </div>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default Configrations
